<template>
  <div class="item-completed-loan-task item-row-alignment-center">
    <weex-image
      :src="imageIcon"
      style="height: 42px;width: 42px; margin: 5px"
      :aria-hidden="true"></weex-image>

    <weex-text class="item-task-title">{{getTaskTitle}}</weex-text>
  </div>
</template>

<script>
  import { ImageResourcesUtil } from "@/utils/ImageResourcesUtil";
  import { Activities } from "@/utils/ActivityNavigator";
  import EzUtils from "@/utils/EzUtils";
  import {Constants} from "@/components/Constants";
  import LoanScopeDataHolder from "@/data/model/LoanScopeDataHolder";

  export default {
    name: "NonRepeatableCompletedLoanTaskItem",
    props: {
      LoanTask: {
        type: Object,
        required: true,
        default: () => ({})
      }
    },

    computed: {
      getTaskTitle() {
        const taskName = this.LoanTask && this.LoanTask.name ? this.LoanTask.name : "";
        if (!taskName) {
          return "";
        }
        let taskTitle;
        const activityDescription = Activities.getActivityDescription(taskName);
        if (taskName === Activities.KYC_RETAILER && EzUtils.areEqualString(Constants.FORM_60,
            LoanScopeDataHolder.getLoanCreationIdentifier(), true)
        ) {
          taskTitle = "Documents for Form-60";
        } else if (activityDescription && activityDescription.title) {
          taskTitle = activityDescription.title;
        }

        return taskTitle ? taskTitle : EzUtils.removeUnderscoreFromString(taskName);
      },

      imageIcon() {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.COMPLETED_TASK);
      },
    }
  };
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>

<style scoped>
  .item-completed-loan-task {
    background-color: #ffffff;
    border-width: 1px;
    border-style: solid;
    border-color: #0F8DE8;
  }
</style>
